/**
 * Permalink button & modal
 */
angular.module("modules:mapping").directive("modalMapPermalink", function () {
  return {
    restrict: "A",
    controller: function ($scope, $uibModal, MappingModals) {
      /**
       * Starts the process of getting a map's permalink
       * @return {Promise}
       */
      $scope.getPermalink = function () {
        if (!$scope.map.ID || !$scope.workspace.sharingEnabled) return;

        // If not saved, open a modal prompting the user to save the changes
        if ($scope.isMapDirty) return promptForSave().then($scope.getPermalink);

        return MappingModals.openPermalink($scope.map, $scope.truMap);
      };

      /**
       * Open a modal asking the user to save the map
       * @return {Promise}
       */
      function promptForSave() {
        return MappingModals.openSaveMapChanges("Please save before sharing permalinks.", $scope.saveMap.bind(null, $scope.map));
      }
    },

    link: function (scope, element, attrs) {
      element.click(scope.getPermalink);
    },
  };
});
